'use client';
import Link from 'next/link';
import React from 'react';
import { DeviceType, ImageSlider } from '@mybestbrands/types';
import Image from 'next/image';
import Slider from '@/app/ui/components/slider';
import { trackSSTEvent } from '@/app/utils/tracking';

type ImageItemsProps = {
  images?: ImageSlider[];
  deviceType: DeviceType;
};

const LandingSlider = ({ images, deviceType }: ImageItemsProps) => {
  if (!images) return null;

  return (
    <>
      <Slider deviceType={deviceType} threeItems={true}>
        {images?.map((image) => {
          return (
            <div key={image?.image.altText} onClick={() => trackSSTEvent('black_friday_slider', { url: image?.url })}>
              <Link href={image?.url}>
                <Image
                  src={deviceType === 'mobile' ? image?.imageMobile?.mediaItemUrl : image?.image?.mediaItemUrl}
                  alt={deviceType === 'mobile' ? image?.imageMobile?.altText : image?.image?.altText}
                  width={307}
                  height={213}
                  sizes="100vw"
                  style={{ width: '100%', height: 'auto', aspectRatio: '16/10' }}
                  className={'mb-3'}
                />
              </Link>
            </div>
          );
        })}
      </Slider>
    </>
  );
};

export default LandingSlider;
